import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from 'src/app/services/dateFormat.service';

@Pipe({
  standalone: false,
  name: 'dateFormat',
})

export class DateFormatPipe implements PipeTransform {
  constructor(private dateFormatService: DateFormatService) { }

  transform(value: Date | number | string, format = this.dateFormatService.userDateFormat): string {
    if (typeof value === 'string') {
      value = new Date(Date.parse(value));
    }

    if (typeof value === 'number') {
      return this.dateFormatService.formatTimestampToString(value, format);
    } else if (value instanceof Date) {
      return this.dateFormatService.formatDateTimeToString(value, format);
    }

    return '-';
  }


}
